export default __webpack_public_path__ + "static/media/bg-contact-us.70f5c94c.png";